import { useStatsigClient } from '@statsig/react-bindings';
import { dynamicConfigNames, gateNames } from '../../constants/statsig';

export function useApplicationVideoConfig() {
  const { client } = useStatsigClient();
  const config = client.getDynamicConfig(dynamicConfigNames.educationalVideos);

  const baseUrl = config.get(gateNames.applicationVideo, '');
  const videoUrl = baseUrl ? `${baseUrl}?rel=0&autoplay=0&enablejsapi=1` : '';

  return { videoUrl };
}
